import { ModalContext } from 'context/ModalContext';
import { MODAL_TYPES } from '../constants';
import { useContext } from 'react';

interface IPollSaveChanges {
  onCancel: () => void;
  saveChanges: any;
  pollData: any[];
}

export default function PollSaveChanges({ saveChanges, onCancel, pollData }: IPollSaveChanges) {
  const { showModal } = useContext(ModalContext);

  return (
    <div className="transparent font-lato">
      <div className="relative border-x border-t bg-gray-bg-dark border-gray-300  bg-white pb-7 pt-9 px-7 w-screen md:w-[520px] md:min-h-[100px] rounded-t-lg">
        <div className="flex mb-5">
          <span className="font-bold text-2xl leading-6 text-[#1A1C1D]">Save changes?</span>
        </div>
      </div>
      <div className="flex text-[13px] pb-6 px-4 bg-white rounded-b-lg border-x">
        <button
          className="py-3 px-8 text-black border border-tabBorder ml-auto rounded-[10px] hover:bg-gray-100"
          onClick={onCancel}
        >
          Cancel
        </button>
        <button
          className="bg-red-main py-3 px-8 text-white ml-2 rounded-[10px]"
          onClick={async () => {
            const valueMap = new Map();
            let hasDuplicates = false;
            for (const item of pollData as any) {
              const value = item.display_time;
              if (valueMap.has(value)) {
                hasDuplicates = true;
                break;
              }
              valueMap.set(value, true);
            }
            if (hasDuplicates) {
              showModal(MODAL_TYPES.duplicated_display_time, { pollData });
            } else {
              await saveChanges();
              onCancel();
            }
          }}
        >
          Save changes
        </button>
      </div>
    </div>
  );
}
